import { Epic, ofType } from 'redux-observable';
import { catchError, map, takeUntil, debounceTime, mergeMap } from 'rxjs/operators';

import { loadRedeemRequest, loadRedeemSuccess, loadRedeemFail } from './redeem.actions';
import { IRedeemResponse } from './redeem.types';

export const loadRedeemDataEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(loadRedeemRequest.getType()),
    debounceTime(300),
    mergeMap(({ payload: hashId }: ReturnType<typeof loadRedeemRequest>) =>
      apiService.get(`/api/recipient/${hashId}/redeem`).pipe(
        map((response: IRedeemResponse) => loadRedeemSuccess(response)),
        catchError(errorHandler({ callbacks: loadRedeemFail })),
        takeUntil(action$.ofType(loadRedeemRequest)),
      ),
    ),
  );

export const redeemEpics = [loadRedeemDataEpic];
